import { useEffect, useState } from 'react';

/**
 * False until React has mounted and taken over the DOM.
 *
 * The app is a client-rendered SPA, so there is a window — small on a laptop,
 * not small on a phone over hotel wifi — where the markup is on screen and no
 * handler is attached to it yet. A plain `<form>` in that window still submits
 * the way HTML has always submitted: a full navigation. On the signup wizard
 * that meant the browser reloaded `/register`, the wizard went back to step
 * one, and everything the person had typed was gone, with no error and nothing
 * to suggest they had done anything wrong.
 *
 * Gating the submit button on this closes the window. It is one render late by
 * construction, which is the point.
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
